import React from "react";

interface Props {
    style?:any
}

const EyeIcon:React.FC<Props> = ({style}) => {
    
    
    return (
        <svg style={typeof style !== "undefined" ? style : null} className={"svg-icon"} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16 6.99902C6 6.99902 2 16 2 16C2 16 6 24.999 16 24.999C26 24.999 30 16 30 16C30 16 26 6.99902 16 6.99902Z"
                stroke="#141615" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path
                d="M16 21C18.7614 21 21 18.7614 21 16C21 13.2386 18.7614 11 16 11C13.2386 11 11 13.2386 11 16C11 18.7614 13.2386 21 16 21Z"
                stroke="#141615" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export default EyeIcon